import React from "react";
import { Button, SvgIconProps } from "@mui/material";
import { CustomButtonProps } from "./button-new.types";

const ButtonNew = ({
  text,
  textColor = "#fff",
  bgColor = "#1976d2",
  borderColor = "transparent",
  icon,
  iconPosition = "left",
  iconColor,
  disabled = false,
  ...rest
}: CustomButtonProps) => {
  // Style the icon (e.g. color)
  const styledIcon =
    icon && React.isValidElement<SvgIconProps>(icon)
      ? React.cloneElement(icon, {
          sx: {
            ...(icon.props.sx || {}),
            color: iconColor || textColor,
          },
        })
      : null;

  return (
    <Button
      variant="outlined"
      disabled={disabled}
      {...rest}
      sx={{
        backgroundColor: disabled ? "#f0f0f0" : bgColor,
        borderColor: disabled ? "#cccccc" : borderColor,
        color: disabled ? "#999999" : textColor,
        textTransform: "none",
        px: 2,
        cursor: disabled ? "not-allowed" : "pointer",
        borderRadius: "8px",
        "&:hover": {
          backgroundColor: disabled ? "#f0f0f0" : bgColor,
          opacity: disabled ? 1 : 0.9,
        },
        ...rest.sx,
      }}
      startIcon={iconPosition === "left" ? styledIcon : undefined}
      endIcon={iconPosition === "right" ? styledIcon : undefined}
    >
      {text}
    </Button>
  );
};

export default ButtonNew;
